import React from 'react';

import homeworld from './img/art-pt1-homeworld.jpg';
import objective from './img/icon-pt1-green-star.png';

import { i18n } from '../../i18n';

import Paras         from '../../paras';
import SectionHeader from '../../section-header';
import Screenshot    from '../../screenshot';
import ModalImage    from '../../modal-image';

import * as css from './index.module.css';

const prefix = 'part1.gs';


export default function GettingStarted() {
    const tutorialAnchor = i18n(`${prefix}.ti.anchor`, { md : false })
        .toLowerCase()
        .replace(' ', '');

    return <>
        <SectionHeader name='getting-started' />

        <div className={css.cols}>
            <div className={css.hw}>
                <div className={css.hwCopy}>
                    <h3>{i18n(`${prefix}.hw.header`)}</h3>
                    <Paras path={`${prefix}.hw.para`} />
                </div>
                <div>
                    <img className={css.hwImg} src={homeworld} />
                </div>
            </div>
            <div className='col'>
                <h3>{i18n(`${prefix}.cyc.header`)}</h3>
                <Paras path={`${prefix}.cyc.para`} />
            </div>
        </div>

        <div className={css.movement}>
            <div className={css.movementBody}>
                <div className='col'>
                    <h3>{i18n(`${prefix}.m.header`)}</h3>
                    <Paras path={`${prefix}.m.para`} doReplace={true} />
                </div>
                <div className='col'>
                    <span className={css.movementImg}>
                        <ModalImage path={`${prefix}.m.modal`}>
                            <Screenshot path={`${prefix}.m.img`} className={css.screenshot} />
                        </ModalImage>
                    </span>
                </div>
            </div>
        </div>

        <div className={css.ti} id={tutorialAnchor}>
            <div className='col'>
                <a href={`#${tutorialAnchor}`}>
                    <h3>{i18n(`${prefix}.ti.header`)}</h3>
                </a>
                <p>{i18n(`${prefix}.ti.para.0`)}</p>

                <div className={css.iconWrap}>
                    <img src={objective} />
                    <p>{i18n(`${prefix}.ti.para.1`)}</p>
                </div>

                <p>{i18n(`${prefix}.ti.para.2`)}</p>
            </div>

            <div className={css.tiImgs}>
                <ModalImage path={`${prefix}.ti.modal.0`}>
                    <Screenshot path={`${prefix}.ti.img.0`} />
                </ModalImage>
                <ModalImage path={`${prefix}.ti.modal.1`}>
                    <Screenshot path={`${prefix}.ti.img.1`} />
                </ModalImage>
            </div>
        </div>
    </>;
}

